import Tool, { type ToolButtonComponent } from './Tool';
import React from 'react';
import { ApplicationView, useController } from '@aha-app/mvc';
import ToolButton from '../toolbars/ToolButton';
import WhiteboardController from '../controllers/WhiteboardController';
import { isMindMap } from '../objects/guards';
import MindMapThemes, {
  type MindMapThemeNames,
} from '../objects/MindMapThemes';
import { type MindMapTheme } from '../objects/MindMap';

const ThemeButton: ToolButtonComponent = ApplicationView(() => {
  const controller = useController(WhiteboardController);
  const { selection: mindmap } = controller;
  if (!isMindMap(mindmap)) return null;
  const themes: { name: MindMapThemeNames; theme: MindMapTheme }[] = [];

  for (const name in MindMapThemes) {
    themes.push({
      name: name as MindMapThemeNames,
      theme: MindMapThemes[name],
    });
  }

  themes.sort((a, b) => {
    // Put custom at the end
    if (a.name === 'custom') return 1;
    if (b.name === 'custom') return -1;
    if (a.theme.label < b.theme.label) {
      return -1;
    } else if (a > b) {
      return 1;
    }
    return 0;
  });

  return (
    <aha-menu style={{ minWidth: 40, minHeight: 40 }}>
      <ToolButton
        slot='control'
        onClick={() => controller.actionApplyTool(ToolMindMapTheme)}
        tool={ToolMindMapTheme}
      >
        <aha-icon icon='fa-regular fa-palette' />
      </ToolButton>
      <aha-menu-content>
        {themes.map(item => (
          <aha-menu-item
            key={item.name}
            onClick={() => {
              mindmap.setTheme(item.name);
            }}
            selected={mindmap.themeName === item.name ? true : null}
          >
            {item.theme.label}
          </aha-menu-item>
        ))}
      </aha-menu-content>
    </aha-menu>
  );
});

class ToolMindMapTheme extends Tool {
  static toolName = 'Theme';

  static action() {}

  static enabled() {
    return true;
  }

  static buttonComponent() {
    return ThemeButton;
  }
}

export default ToolMindMapTheme;
